var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWristWatchOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.49786 4.41165C9.77831 3.00938 11.0096 2 12.4396 2H15.5604C16.9904 2 18.2217 3.00938 18.5021 4.41165L18.9112 6.45684C20.885 7.74456 22.3222 9.78603 22.8144 12.1728C23.5131 12.4846 24 13.1855 24 14C24 14.8145 23.5131 15.5154 22.8144 15.8272C22.3222 18.214 20.885 20.2554 18.9112 21.5431L18.5021 23.5883C18.2217 24.9906 16.9904 26 15.5604 26H12.4396C11.0096 26 9.77833 24.9906 9.49788 23.5883L9.08884 21.5432C6.6271 19.9371 5 17.1586 5 14C5 10.8414 6.62709 8.06291 9.08882 6.45685L9.49786 4.41165ZM11.3399 5.3996C12.1806 5.13986 13.074 5 14 5C14.926 5 15.8194 5.13985 16.6601 5.39959L16.541 4.80388C16.4475 4.33646 16.0371 4 15.5604 4H12.4396C11.9629 4 11.5525 4.33646 11.459 4.80388L11.3399 5.3996ZM11.3399 22.6004L11.459 23.1961C11.5525 23.6635 11.9629 24 12.4396 24H15.5604C16.0371 24 16.4475 23.6635 16.541 23.1961L16.6601 22.6004C15.8194 22.8601 14.926 23 14 23C13.074 23 12.1806 22.8601 11.3399 22.6004ZM21 14C21 17.866 17.866 21 14 21C10.134 21 7 17.866 7 14C7 10.134 10.134 7 14 7C17.866 7 21 10.134 21 14ZM15 10C15 9.44772 14.5523 9 14 9C13.4477 9 13 9.44772 13 10V14C13 14.4 13.2384 14.7616 13.6061 14.9191L17.1061 16.4191C17.6137 16.6367 18.2016 16.4015 18.4191 15.8939C18.6367 15.3863 18.4015 14.7984 17.8939 14.5809L15 13.3406V10Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWristWatchOutline);
export default __webpack_public_path__ + "static/media/wrist_watch_outline.0ef5903d3321c93f71a9f942ae211823.svg";
export { ForwardRef as ReactComponent };